/* eslint-disable */
export default {
  from: 'From',
  to: 'To',
  enterNameOrNumber: 'Enter number or name...',
  typeMessage: 'Type message...',
  send: 'Send',
  emoji: 'Emoji',
} as const;

// @key: @#@"from"@#@ @source: @#@"From"@#@
// @key: @#@"to"@#@ @source: @#@"To"@#@
// @key: @#@"enterNameOrNumber"@#@ @source: @#@"Enter Number or Name..."@#@
// @key: @#@"typeMessage"@#@ @source: @#@"Type message..."@#@
// @key: @#@"send"@#@ @source: @#@"Send"@#@
// @key: @#@"emoji"@#@ @source: @#@"Emoji"@#@
